
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PasswordForm = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState("\u00A0");
  const [isMatch, setIsMatch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
const navigate = useNavigate();

  // ⬅️ Read reset token from URL, not from localStorage
  const { token } = useParams();

  const checkPasswords = (pw, cf) => {
    if (pw.length === 0 && cf.length === 0) {
      setMessage("\u00A0");
      setIsMatch(false);
      return;
    }
    if (pw.length < 6) {
      setMessage("Password must contain at least 6 characters.");
      setIsMatch(false);
      return;
    }
    if (pw === cf) {
      setMessage("Passwords match.");
      setIsMatch(true);
    } else {
      setMessage("Passwords do not match.");
      setIsMatch(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isMatch) return;

    setLoading(true);
    setApiMessage("");

    const token = new URLSearchParams(window.location.search).get("token");
    //console.log("📌 Token:", token);

    console.log("📤 Sending Reset Request =>", {
      token,
      newPassword: password,
      confirmPassword: confirm,
    });

    try {
      const response = await fetch(
        `https://backend.maamaas.com/subscription/api/reset/${token}`,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            newPassword: password,
            confirmPassword: confirm,
          }),
        }
      );

      const text = await response.text();
      //console.log("📥 API Response RAW:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
  setApiMessage(data.message || "Password reset successfully!");
  setPassword("");
  setConfirm("");
  setIsMatch(false);

  // Redirect to home page after success
  setTimeout(() => {
    navigate("/");
  }, 1500); // optional delay to show success message
} else {
  console.error("❌ ERROR:", data.message);
  setApiMessage(data.message || "Something went wrong!");
}
    } catch (err) {
      console.error("🚫 Network Error:", err);
      setApiMessage("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; font-family: Inter, system-ui, sans-serif; }
        body, html, #root { height: 100%; }
        .wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 20px; background: linear-gradient(135deg,#eef2ff 0%, #f8fafc 100%); }
        .card { width: 100%; max-width: 420px; background: #fff; border-radius: 14px; box-shadow: 0 8px 30px rgba(30,40,60,0.08); padding: 28px; border: 1px solid rgba(15,23,42,0.04); }
        h1 { font-size: 20px; margin-bottom: 12px; color: #0f172a; text-align: center; }
        p.lead { font-size: 13px; color: #475569; text-align: center; margin-bottom: 20px; }
        form { display: flex; flex-direction: column; gap: 14px; }
        .field { display: flex; flex-direction: column; gap: 8px; }
        label { font-size: 13px; color: #0f172a; }
        .input-row { position: relative; }
        input[type="password"], input[type="text"] { width: 100%; padding: 12px 44px 12px 12px; border-radius: 8px; border: 1px solid #e6eef8; font-size: 14px; }
        .toggle-btn { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: transparent; border: 0; padding: 6px; cursor: pointer; font-size: 13px; color: #64748b; }
        .help { font-size: 13px; color: #ef4444; min-height: 18px; }
        .help.ok { color: #16a34a; }
        .api-message { font-size: 14px; text-align: center; margin-top: 10px; color: #2563eb; min-height: 18px; }
        button[type="submit"] { margin-top: 6px; padding: 12px; border-radius: 8px; border: 0; font-weight: 600; font-size: 15px; background: #2563eb; color: #fff; cursor: pointer; transition: all .18s ease; }
        button[type="submit"]:disabled { opacity: 0.6; cursor: not-allowed; background: #93c5fd; }
        @media (max-width: 420px) { .card { padding: 20px; } }
      `}</style>

      <div className="wrap">
        <div className="card">
          <h1>Create a Secure Password</h1>
          <p className="lead">Enter and confirm password. Submit will enable only when both match.</p>

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="input-row">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    checkPasswords(e.target.value, confirm);
                  }}
                  placeholder="Enter your password"
                  required
                  minLength="6"
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="field">
              <label htmlFor="confirm">Confirm Password</label>
              <div className="input-row">
                <input
                  id="confirm"
                  type={showConfirm ? "text" : "password"}
                  value={confirm}
                  onChange={(e) => {
                    setConfirm(e.target.value);
                    checkPasswords(password, e.target.value);
                  }}
                  placeholder="Re-enter your password"
                  required
                  minLength="6"
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className={"help " + (isMatch ? "ok" : "")}>{message}</div>
            <button type="submit" disabled={!isMatch || loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
            <div className="api-message">{apiMessage}</div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordForm;

